import { useCallback, useEffect } from "react";
import { createPortal } from "react-dom";
import { CLOUDINARY_BASE_URL } from "../../config/cloudinary";
import s from "./ImageLightbox.module.scss";

const toImageUrl = (src) => {
  const value = String(src || "");

  if (!value) return "";
  if (value.startsWith("http") || value.startsWith("data:")) return value;

  return `${CLOUDINARY_BASE_URL}${value.replace(/^\/+/, "")}`;
};

export const ImageZoomButton = ({
  onClick,
  className = "",
  label = "拡大",
  ariaLabel = "画像を大きく見る",
}) => {
  return (
    <button
      type="button"
      className={`${s.zoomButton} ${className}`}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.();
      }}
      aria-label={ariaLabel}
      title={label}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M8 3H3v5" />
        <path d="M3 3l7 7" />
        <path d="M16 3h5v5" />
        <path d="M21 3l-7 7" />
        <path d="M8 21H3v-5" />
        <path d="M3 21l7-7" />
        <path d="M16 21h5v-5" />
        <path d="M21 21l-7-7" />
      </svg>
      <span>{label}</span>
    </button>
  );
};

const ImageLightbox = ({ image, alt = "", onClose }) => {
  const close = useCallback(() => {
    onClose?.();
  }, [onClose]);

  useEffect(() => {
    if (!image) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") close();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [close, image]);

  if (!image) return null;

  return createPortal(
    <div className={s.modal} role="dialog" aria-modal="true">
      <button
        className={s.backdrop}
        type="button"
        onClick={close}
        aria-label="画像を閉じる"
      />

      <div className={s.inner}>
        <button
          className={s.close}
          type="button"
          onClick={close}
          aria-label="画像を閉じる"
        >
          ×
        </button>

        <img
          src={toImageUrl(image)}
          alt={alt}
          loading="eager"
          decoding="async"
        />
      </div>
    </div>,
    document.body,
  );
};

export default ImageLightbox;
